import React, { useRef } from "react";
import PropTypes from "prop-types";
import FilterChip from "./FilterPanel/FilterChip";

const FILTER_LABELS = {
  status:    v => `Status: ${v.replace(/_/g, " ")}`,
  priority:  v => `Priority: ${v}`,
  date_from: v => `From: ${v}`,
  date_to:   v => `To: ${v}`,
};

export default function FilterBar({
  search, onSearchChange, onRefresh, loading,
  filters, onFilterRemove, onFiltersOpen, activeFilterCount,
  rightSlot,
}) {
  const inputRef = useRef(null);

  const activeFilters = Object.entries(filters || {}).filter(([, v]) => Boolean(v));

  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        {/* Search */}
        <div className="rp-search-wrap">
          <i className="bi bi-search rp-search-icon" />
          <input
            ref={inputRef}
            type="text"
            className="rp-search-input"
            placeholder="Search requests, ref #, or fields…"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {search && (
            <button className="rp-search-clear" onClick={() => onSearchChange("")} title="Clear">
              <i className="bi bi-x" />
            </button>
          )}
        </div>

        {/* Filters button */}
        <button
          className={`t2t-btn t2t-btn-sm d-flex align-items-center gap-1${activeFilterCount > 0 ? " t2t-btn-outline" : " t2t-btn-ghost"}`}
          onClick={onFiltersOpen}
          title="Open filters"
        >
          <i className="bi bi-funnel" style={{ fontSize: 12 }} />
          <span>Filters</span>
          {activeFilterCount > 0 && (
            <span className="rp-chip-count" style={{ marginLeft: 2 }}>{activeFilterCount}</span>
          )}
        </button>

        {/* Refresh */}
        <button
          className="t2t-btn t2t-btn-ghost t2t-btn-sm"
          onClick={onRefresh}
          disabled={loading}
          title="Refresh"
          style={{ opacity: loading ? 0.5 : 1 }}
        >
          <i className={`bi bi-arrow-clockwise${loading ? " t2t-spin" : ""}`} />
        </button>

        {/* Right slot — ColumnPicker injected by parent */}
        {rightSlot && <div className="ms-auto d-flex align-items-center gap-2">{rightSlot}</div>}
      </div>

      {/* Active filter chips row */}
      {activeFilters.length > 0 && (
        <div className="d-flex flex-wrap align-items-center gap-1">
          {activeFilters.map(([key, val]) => (
            <FilterChip
              key={key}
              label={(FILTER_LABELS[key] || (k => k))(val)}
              onRemove={() => onFilterRemove(key)}
            />
          ))}
          <button
            className="t2t-btn t2t-btn-ghost"
            style={{ fontSize: 11, padding: "2px 6px" }}
            onClick={() => activeFilters.forEach(([k]) => onFilterRemove(k))}
          >
            Clear all
          </button>
        </div>
      )}
    </div>
  );
}

FilterBar.propTypes = {
  search:            PropTypes.string,
  onSearchChange:    PropTypes.func.isRequired,
  onRefresh:         PropTypes.func.isRequired,
  loading:           PropTypes.bool,
  filters:           PropTypes.object,
  onFilterRemove:    PropTypes.func,
  onFiltersOpen:     PropTypes.func,
  activeFilterCount: PropTypes.number,
  rightSlot:         PropTypes.node,
};
